import React from 'react';

import {Icon, IconNames} from '../../../../Icon';
import {Tooltip} from '../../../../Tooltip';

type FeatureSupportIndicatorProps = {
  label: string;
  isSupported: boolean;
  tooltip?: string;
};

export const FeatureSupportIndicator = ({
  isSupported,
  label,
  tooltip,
}: FeatureSupportIndicatorProps) => {
  const iconName = isSupported ? IconNames.Checkmark : IconNames.Close;
  const color = isSupported ? 'green' : 'red';
  const icon = <Icon color={color} name={iconName} />;
  const trigger = (
    <div className="flex items-center gap-4">
      {icon}
      {label}
    </div>
  );
  if (!tooltip) {
    return trigger;
  }
  const tooltipContent = (
    <span>
      <strong>
        {label} is {isSupported ? 'supported' : 'not supported'}
      </strong>
      <br />
      <div className="text-moon-200 text-xs max-w-[300px]">{tooltip}</div>
    </span>
  );
  return <Tooltip trigger={trigger} content={tooltipContent} />;
};
